import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Dropdown } from "react-bootstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Modal } from "react-bootstrap";
import { ExploreRightArrow } from "../../../../SvgIconsData";
import axios from "axios";
import { defaultLogo } from "../../../../env";
import NoDataFound from "../../../NoDataFound";
import { CloseIcon, CrownIcon } from "../../../../assets/icons/iconshere";
import { platformIcon } from "../../../../utils/useWindowDimensions";
import Skeleton from "react-loading-skeleton";
import ProPopup from "../../../layouts/ProPopup";

const CoursesCard = ({ list, page = "myLearning", loading, atHome, courseSize }) => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const appData = useSelector((state) => state.applicationSlice);
  let _platforms = appData?.tags?.data?.children?.filter((e) => e.name == "Platform")[0] || [];
  const [permissions, setPermissions] = useState([]);
  const [showAddModule, setShowAddModule] = useState({
    uuid: null,
    status: false,
  });

  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  const queryRequestValidation = Yup.object().shape({
    name: Yup.string().required("Name is required."),
    email: Yup.string().email("Invalid email address.").required("Email is required."),
    description: Yup.string().required("Description is required."),
  });

  const location = useLocation();

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      description: "",
    },
    validationSchema: queryRequestValidation,
    onSubmit: async (values) => {
      try {
        let _data = {
          name: values.name,
          email: values.email,
          description: values.description,
        };

        await axios.post(
          `${configData.config.UNO_URL}/api/user/request/${configData.config.applicationId}/${showAddModule.uuid}`,
          _data,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`,
            },
          }
        );
      } catch (error) {
        console.log(error);
      } finally {
        closeQueryModal();
      }
    },
  });

  useEffect(() => {
    if (userData.user.permissions?.length > 0) {
      setPermissions([...userData.user.permissions]);
    }
  }, [userData.user]);

  const handleClick = (event, e, type) => {
    event.stopPropagation();
    if (!type) {
      setOpenPro(true);
      return;
    }
    navigate(`/module/report/group/${userData.user.group.uuid}/${e.uuid}`, {
      state: { group: userData.user.group, module: e },
    });
  };

  const handleMyLearning = (event, e) => {
    event.stopPropagation();
    navigate(`/course/details/${e.uuid}`, {
      state: {
        name: e.name || "",
        userUUID: userData.user.uuid,
        previousLocationPathname: location.pathname || null,
      },
    });
  };

  const closeQueryModal = () => {
    setShowAddModule({
      uuid: null,
      status: false,
    });
    formik.resetForm();
  };


  return (
    <>
      {loading ? (
        <>
          <div className="courses-parent">
            <div className="course-tiles">
              {Array(4)
                .fill(1)
                .map((e, i) => {
                  return (
                    <div key={`tile-${i}`} className="tilecard">
                      <div className="course-card">
                        <div className="projectthumb">
                          <Skeleton height={120} />
                        </div>
                        <div className="card-body-main">
                          <Skeleton />
                        </div>
                        <div className="card-body-des">
                          <Skeleton />
                        </div>
                        <div className="devicelist">
                          <Skeleton width={25} height={25} circle />
                          <Skeleton width={25} height={25} circle /> <Skeleton width={25} height={25} circle />
                        </div>

                        <div className="card-footer p-1 ">
                          <div className="row">
                            <div className="col-12 p-0 px-2">
                              <Skeleton width={100} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      ) : (
        <>
          {list?.length > 0 ? (
            <div className="">
              <div className={atHome ? "courses-parent home-explore" : "courses-parent"}>
                <div className="course-tiles">
                  {list.map((e) => {
                    let modulePlatformTags =
                      e?.tags?.length > 0 ? e.tags.filter((e) => e.categoryId == _platforms.id) : [];
                    return (
                      <>
                        <div className="tilecard " key={e.uuid}>
                          <div className="course-card" onClick={(event) => handleMyLearning(event, e)}>
                            <div className="projectthumb">
                              {e.versions[0]?.data?.thumbnail ? (
                                <img src={e.versions[0]?.data?.thumbnail} alt="" />
                              ) : (
                                <img src={defaultLogo} className="p-4" />
                              )}
                            </div>

                            <div className="card-body-main">
                              <p> {e?.name || ""} </p>
                            </div>

                            <div className="card-body-des">
                              <Tooltip enterDelay={2000} title={e.versions[0]?.data?.short || ""}>
                                <p> {e.versions[0]?.data?.short || ""} </p>
                              </Tooltip>
                            </div>

                            <div className="devicelist">
                              {modulePlatformTags.map((e, f) => {
                                return (
                                  <Tooltip key={f} title={e.name}>
                                    <img src={platformIcon[e.name]} alt="" />
                                  </Tooltip>
                                );
                              })}
                            </div>

                            {page == "myLearning" ? (
                              <div className="card-footer p-1 ">
                                <div className="row">
                                  <div className="col-12 text-center p-0 px-2 allcardbtns">
                                    {configData.config.MODE === "XR" &&
                                      permissions.includes("XR.DASHBOARD.OWN") ? (
                                      userPlan && userPlan?.courseDetail?.analytics ? (
                                        <button
                                          onClick={(event) => handleClick(event, e, true)}
                                          className="startmodule"
                                        >
                                          Analytics
                                        </button>
                                      ) : (
                                        <button
                                          onClick={(event) => handleClick(event, e, false)}
                                          className="startmodule"
                                        >
                                          Analytics
                                        </button>
                                      )
                                    ) : null}

                                    {configData.config.MODE === "XR" &&
                                      permissions.includes("XR.DASHBOARD.PLAYCOURSE") && (
                                        <button className="btn m-0" title="Play">
                                          Start Module
                                        </button>
                                      )}

                                    {configData.config.MODE === "2D" && (
                                      <button className="btn m-0" title="Play">
                                        Start Module
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="card-footer p-1 ">
                                <div className="row">
                                  <div className="col-12 text-center p-0 px-2">
                                    <button className="gotocourse" onClick={(event) => handleMyLearning(event, e)}>
                                      Go To Course
                                      <ExploreRightArrow />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <>
              <NoDataFound nodatatext={"No results found"} />
            </>
          )}
        </>
      )}
      <Modal show={showAddModule.status} onHide={closeQueryModal} className="NewModule" centered size="md">
        <Modal.Header className="modalheader">
          Query Form
          <span onClick={closeQueryModal}>
            {" "}
            <CloseIcon />{" "}
          </span>
        </Modal.Header>
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="label">
                      {" "}
                      Name
                      <input
                        type="text"
                        autoComplete="off"
                        value={formik.values.name}
                        onChange={(event) => formik.setFieldValue(event.target.name, event.target.value)}
                        placeholder="name"
                        name="name"
                        id="name"
                        className={`form-control ${formik.errors.name && formik.touched.name ? "is-invalid" : ""}`}
                      />
                      {formik.errors.name && formik.touched.name && (
                        <p className="text-danger px-2 text-sm fw-bold">{formik.errors.name}</p>
                      )}
                    </label>
                  </div>
                </div>

                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="label">
                      {" "}
                      Email
                      <input
                        type="text"
                        autoComplete="off"
                        value={formik.values.email}
                        onChange={(event) => formik.setFieldValue(event.target.name, event.target.value)}
                        placeholder="email"
                        name="email"
                        id="email"
                        className={`form-control ${formik.errors.email && formik.touched.email ? "is-invalid" : ""}`}
                      />
                      {formik.errors.email && formik.touched.email && (
                        <p className="text-danger px-2 text-sm fw-bold">{formik.errors.email}</p>
                      )}
                    </label>
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="form-group">
                    <label className="label">
                      {" "}
                      Description
                      <textarea
                        type="text"
                        autoComplete="off"
                        value={formik.values.description}
                        onChange={(event) => formik.setFieldValue(event.target.name, event.target.value)}
                        placeholder="description"
                        name="description"
                        id="description"
                        className={`form-control ${formik.errors.description && formik.touched.description ? "is-invalid" : ""
                          }`}
                      />
                      {formik.errors.description && formik.touched.description && (
                        <p className="text-danger px-2 text-sm fw-bold">{formik.errors.description}</p>
                      )}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="footerbtn pt-0">
            <button className="cancel" onClick={closeQueryModal}>
              {" "}
              Cancel{" "}
            </button>
            <button className="save" type="submit">
              {" "}
              Send{" "}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};

export default CoursesCard;
